export default "__VITE_PUBLIC_ASSET__d6bfb896__"